<template>
  <div class="font-heiti">
    <div class="flex flex-nowrap space-x-1 font-semibold" style="margin-bottom: 1px;">
      <div class="flex-1">
        <div class="bg-yellow-level text-right text-white px-1 min-w-max relative" :style="`width: ${Math.min(100, Math.max((yellow.label + '' || yellow.val + '').length, yellow.val))}%`">
          {{yellow.label || yellow.val}}
          <span v-if="yellow.rate" class="text-left text-yellow-level absolute" :class="['', '-right-4', '-right-6', '-right-8', '-right-10', '-right-11', '-right-11', '-right-11'][getByteLength(yellow.rate)]">{{yellow.rate || ''}}</span>
        </div>
      </div>
      <div class="text-left text-yellow-level w-14">&nbsp;</div>
    </div>
    <div class="flex flex-nowrap space-x-1 font-semibold">
      <div class="flex-1">
        <div class="bg-blue-level text-right text-white px-1" :style="`width: ${Math.min(100, Math.max(10, blue.val))}%`">{{blue.label || blue.val}}</div>
      </div>
      <div class="text-left text-blue-level w-14"></div>
    </div>
  </div>
</template>

<script>
export default {
  props: ['yellow', 'blue'],
  methods: {
    getByteLength (str) {
      return TextEncoder ? new TextEncoder().encode(str).length : str.length
    }
  }
}
</script>
